<template>
  <div class="bg-white p-4">
    <div
      class="absolute right-0 top-0 bg-purple-500 h-8 w-8 text-center rounded-tr-md rounded-bl-md cursor-pointer"
    >
      <eva-icon
        class="color-red mt-1"
        name="close-outline"
        fill="#fff"
        @click="$emit('close')"
      />
    </div>
    <tag-manager
      :disabled="saving"
      :success="success"
      :selectableTags="tags"
      :currentTags="currentTags"
      :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/ }"
      @tag:add="addTag"
      @tag:remove="removeTag"
      @state:search="isSearching = $event"
    >
      Etiquetas para población:
    </tag-manager>
    <div
      class="px-3 py-1 my-1 rounded-b-md mt-5 cursor-pointer bg-purple-500 text-white text-center text-xl"
      @click="save"
    >
      <div
        class="inline-block"
      >
        <eva-icon
          name="save-outline"
          fill="#FFFFFF"
        />
      </div>
      Guardar
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import * as axios from 'axios'
import { db } from '../utils/firebase'
import tagManager from '../components/tagManager'

export default {
  name: 'PopulationCard',
  components: {
    tagManager,
  },
  data () {
    return {
      currentTags: {},
      success: false,
      saving: false,
    }
  },
  computed: {
    ...mapState({
      instanceID: state => state.admin.instanceID,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  watch: {
  },
  async mounted () {
    db.collection('instances').doc(this.instanceID).onSnapshot(instance => {
      if (instance.exists) {
        this.$store.commit('admin/setInstanceTags', instance.data().tags)
      }
    })
  },
  methods: {
    async save () {
      try {
        this.$f7.dialog.preloader('Creando población')
        await axios({
          url: '/populations/create',
          method: 'POST',
          data: {
            instanceID: this.instanceID,
            tagIDs: Object.keys(this.currentTags),
            originTagIDs: Object.keys(this.currentTags),
          },
        })
        this.$f7.dialog.close()
        this.currentTags = {}
        this.$emit('close')
      } catch (err) {
        this.$f7.dialog.close()
        console.error(err)
      }
    },
    addTag (tagID) {
      if (tagID) {
        if (!this.currentTags[tagID]) {
          this.$set(this.currentTags, tagID, this.tags[tagID])
        }
      }
    },
    removeTag (tagID) {
      this.$delete(this.currentTags, tagID)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
